<template>
  <ValidationObserver ref="observer">
  <v-row>
    <v-col cols="4" md="4">
      <ValidationProvider
              v-slot="{ errors }"
              :name="$t('HuifuAccount.Fields.reg_prov_id')"
              rules="required"
      >
        <v-autocomplete
          color="primary"
          hide-no-data
          v-model="provinceSelected"
          clearable
          :items="provinceItems"
          :loading="provincesLoading"
          :search-input.sync="provincesSearch"
          item-text="name"
          item-value="id"
          item-disabled="disabled"
          :label="$t('Area.city_1')"
          return-object
          :single-line="dense"
          :dense="dense"
          :hide-details="dense"
          :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
          :error-messages="errors"
        >
          <template v-slot:message="{ key, message }">
            <div :class="key == 0 ? 'danger--text' : ''">
              {{ message }}
            </div>
          </template>
        </v-autocomplete>
      </ValidationProvider>
    </v-col>
    <v-col cols="4" md="4">
      <ValidationProvider
              v-slot="{ errors }"
              :name="$t('HuifuAccount.Fields.reg_area_id')"
              rules="required"
      >
      <v-autocomplete
        color="primary"
        hide-no-data
        v-model="citySelected"
        clearable
        :items="cityItems"
        :loading="citiesLoading"
        :search-input.sync="citiesSearch"
        item-text="name"
        item-value="id"
        :label="$t('Area.city_2')"
        return-object
        :single-line="dense"
        :dense="dense"
        :hide-details="dense"
        :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
        :error-messages="errors"
      > <template v-slot:message="{ key, message }">
        <div :class="key == 0 ? 'danger--text' : ''">
          {{ message }}
        </div>
      </template>
      </v-autocomplete>
      </ValidationProvider>
    </v-col>
    <v-col cols="4" md="4">
      <ValidationProvider
              v-slot="{ errors }"
              :name="$t('HuifuAccount.Fields.reg_district_id')"
              rules="required"
      >
      <v-autocomplete
        color="primary"
        hide-no-data
        v-model="districtSelected"
        clearable
        :items="districtItems"
        :loading="districtsLoading"
        :search-input.sync="districtsSearch"
        item-text="name"
        item-value="id"
        :label="$t('Area.city_3')"
        return-object
        :single-line="dense"
        :dense="dense"
        :hide-details="dense"
        :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
        :error-messages="errors"
      > <template v-slot:message="{ key, message }">
        <div :class="key == 0 ? 'danger--text' : ''">
          {{ message }}
        </div>
      </template>
      </v-autocomplete>
      </ValidationProvider>
    </v-col>
  </v-row>
  </ValidationObserver>
</template>
<script>
import HfdgInterface from "@/api/hfdgInterface";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "CitiesHFSelectGroup",

  components: {
    ValidationObserver,
    ValidationProvider,
  },

  props: {
    noLabel: Boolean,
    dense: Boolean,
    masterItem: Object,
  },

  data: () => ({
    provinceItems: [],
    cityItems: [],
    districtItems: [],
    provinceItemsObj: null,
    cityItemsObj: null,
    districtItemsObj: null,
    provinceSelected: null,
    citySelected: null,
    districtSelected: null,
    provincesLoading: false,
    citiesLoading: false,
    districtsLoading: false,
    provincesSearch: "",
    citiesSearch: "",
    districtsSearch: "",
    provinceCode: null,
    cityCode: null,
    districtCode: null,

  }),

  mounted() {
    //获取一级地址
    HfdgInterface.select({ rank: 1 }).then(
      function (response) {
        if (response.data.status.isOK()) {
          this.provinceItemsObj = response.data.cities;
          this.provinceItems = response.data.cities;
        }
      }.bind(this)
    );
  },

  watch: {
    provinceItemsObj: {
      handler() {
        //默认选中已设置的一级地址
        if (this.masterItem.hfdg_province_id && this.provinceItemsObj) {
          this.provinceSelected = {
            id: this.masterItem.hfdg_province_id,
            code: this.masterItem.reg_prov_id
          };
        }
      },
    },
    provinceSelected: {
      handler() {
        if (this.provinceSelected && this.provinceSelected.id) {
          //同步选择的一级地址
          this.$emit("provinceCode", this.provinceSelected.code);
          //获取二级地址
          HfdgInterface.select({
            rank: 2,
            parent_city_id: this.provinceSelected.id,
          }).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.cityItemsObj = response.data.cities;
                this.cityItems = response.data.cities;
              }
            }.bind(this)
          );
        } else {
          this.$emit("provinceCode", null);
          this.cityItems = [];
          this.citySelected = null;
        }
      },
    },
    cityItems: {
      deep: true,
      handler() {
        if (this.cityItems) {
          //默认选中已设置的二级地址
          if (this.masterItem.hfdg_city_id && this.cityItemsObj) {
            this.citySelected = {
              id: this.masterItem.hfdg_city_id,
              code: this.masterItem.reg_area_id
            };
          }
        }
      },
    },
    citySelected: {
      handler() {
        if (this.citySelected && this.citySelected.id) {
          //同步选择的二级地址
          this.$emit("cityCode", this.citySelected.code);
          //获取三级地址
          HfdgInterface.select({
            rank: 3,
            parent_city_id: this.citySelected.id,
          }).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.districtItemsObj = response.data.cities;
                this.districtItems = response.data.cities;
              }
            }.bind(this)
          );
        } else {
          this.$emit("cityCode", null);
          this.districtItems = [];
          this.districtSelected = null;
        }
      },
    },
    districtItems: {
      deep: true,
      handler() {
        if (this.districtItems) {
          //默认选中已设置的二级地址
          if (this.masterItem.hfdg_area_id && this.districtItemsObj) {
            this.districtSelected = {
              id: this.masterItem.hfdg_area_id,
              code: this.masterItem.reg_district_id,
            };
          }
        }
      },
    },
    districtSelected: {
      handler() {
        if (this.districtSelected && this.districtSelected.id) {
          //同步选择的三级地址
          this.$emit("districtCode", this.districtSelected.code);
        } else {
          this.$emit("districtCode", null);
        }
      },
    },
  },
};
</script>